module.exports = __webpack_public_path__ + "media/images/help/flow/bg-rail-01-a228e6a171a7bf0e5f1d3a4b1db3706c.svg";